import { createContext, useContext } from 'react'

const EmblaContext = createContext(null)

export const useEmblaContext = () => useContext(EmblaContext)

export const EmblaProvider = ({ children, emblaApi }) => {
	return (
		<EmblaContext.Provider value={emblaApi}>
			{children}
		</EmblaContext.Provider>
	)
}